import React from 'react';
import { useStore } from 'effector-react';
import { SceneType } from '@types';
import { $loadedScene } from '@stores/loadedStore';
import { PanelRotateItemMatrix } from './PanelRotateItemMatrix';
import { PanelRotateItemPano } from './PanelRotateItemPano';

interface Props {
  id: string;
  onRequestClose: () => void;
}

export function PanelRotateItem({ id, onRequestClose }: Props) {
  const scene = useStore($loadedScene)!;
  if (scene.type === SceneType.matrix) {
    return <PanelRotateItemMatrix id={id} onRequestClose={onRequestClose} />;
  }
  return <PanelRotateItemPano id={id} onRequestClose={onRequestClose} />;
}
